export class RangeForm {
  public static MIN_PHONE = 10;
  public static MAX_PHONE = 15;
  public static MIN_COUNTRY_PHONE = 1;
  public static MAX_COUNTRY_PHONE = 3;
  public static MIN_CREDIT_CARD = 12;
  public static MAX_CREDIT_CARD = 19;
  public static MIN_CVV = 3;
  public static MAX_CVV = 4;
  public static MIN_ZIP = 5;
  public static MIN_NAME = 50;
  public static MIN_EMAIL = 50;
  public static MIN_STREET = 50;
  public static MIN_TEXT = 100;
}
